import React from 'react';
import { Card, CardContent } from '../ui/card';
import { 
  Target,
  CheckCircle,
  TrendingUp,
  Award
} from 'lucide-react';

const ProfileStats = ({ stats }) => {
  const statItems = [
    {
      icon: Target,
      value: stats.totalProjects,
      label: 'Total Projects',
      color: 'blue'
    },
    {
      icon: CheckCircle,
      value: stats.completedTasks,
      label: 'Completed Tasks',
      color: 'green'
    },
    {
      icon: TrendingUp,
      value: stats.activeProjects,
      label: 'Active Projects',
      color: 'orange'
    },
    {
      icon: Award,
      value: '87%',
      label: 'Completion Rate',
      color: 'purple'
    }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      blue: 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400',
      green: 'bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400',
      orange: 'bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400',
      purple: 'bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400'
    };
    return colorMap[color] || colorMap.blue;
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {statItems.map((item, index) => {
        const Icon = item.icon;
        return (
          <Card key={index}>
            <CardContent className="p-6">
              <div className="flex items-center gap-4">
                <div className={`p-3 rounded-lg ${getColorClasses(item.color)}`}>
                  <Icon className="w-6 h-6" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">{item.value}</p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">{item.label}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default ProfileStats;
